import React, { useState } from 'react';

export default function TeamSection() {
  const [activeCard, setActiveCard] = useState(null);

  const teamMembers = [
    {
      id: 1,
      name: 'Darrell Steward',
      role: 'AI AGENT',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    },
    {
      id: 2,
      name: 'Annette Black',
      role: 'AI AGENT',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop',
    },
    {
      id: 3,
      name: 'Clara Ross',
      role: 'AI AGENT',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    },
    {
      id: 4,
      name: 'Sidharth Chandan',
      role: 'AI AGENT',
      image: 'https://media.istockphoto.com/id/1415992796/photo/indian-young-man-sitting-on-a-park-bench-and-working-on-laptop-in-outdoor-fresh-hair-at-day.jpg?s=1024x1024&w=is&k=20&c=OwULKZlNVRFOK1AIBYRtUe1XqHk-eUyqXy8051rt7p0=',
    },
  ];

  return (
    <div className="bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center relative overflow-hidden px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12 py-8">
      {/* Decorative background elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-purple-200 rounded-full opacity-30 blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-pink-200 rounded-full opacity-30 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-orange-200 rounded-full opacity-20 blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="w-full">
        {/* Header Section */}
        <div className="text-center mb-16 animate-fadeInDown">
          <div className="flex items-center justify-center mb-6">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900">
              Meet The Professionals
              <br />
              Behind Our Success
            </h1>
          </div>
        </div>

        {/* Team Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 lg:max-h-  gap-8 max-w-6xl mx-auto">
          {teamMembers.map((member, index) => (
            <div
              key={member.id}
              className="relative group animate-fadeInUp"
              style={{ animationDelay: `${index * 0.2}s` }}
              onMouseEnter={() => setActiveCard(member.id)}
              onMouseLeave={() => setActiveCard(null)}
            >
              {/* Card Container */}
              <div className="relative bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-4">
                {/* Plus Button */}
                <button 
                  className="absolute -top-6 -right-6 w-14 h-14 bg-gradient-to-br from-purple-500 to-fuchsia-600 rounded-full flex items-center justify-center shadow-lg z-10 transform transition-all duration-300 hover:scale-110 hover:rotate-90"
                  aria-label={`View more about ${member.name}`}
                >
                  <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                  </svg>
                </button>

                {/* Image Container */}
                <div className="relative h-80 overflow-hidden rounded-t-3xl">
                  {/* Placeholder for image - replace with actual images */}
                  <div className="absolute inset-0 bg-gradient-to-br from-purple-100 to-pink-100">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                    />
                  </div>
                  
                  {/* Overlay gradient */}
                  {/* <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div> */}
                  
                  {/* Animated border glow */}
                  {/* <div className={`absolute inset-0 rounded-t-3xl transition-opacity duration-500 ${
                    activeCard === member.id ? 'opacity-100' : 'opacity-0'
                  }`}>
                    <div className="absolute inset-0 rounded-t-3xl bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500 opacity-20 animate-pulse"></div>
                  </div> */}
                </div>

                {/* Info Section */}
                <div className="p-8 text-center relative">
                  {/* Decorative element */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-1 bg-gradient-to-r from-transparent via-purple-400 to-transparent"></div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-purple-600 transition-colors duration-300">
                    {member.name}
                  </h3>
                  <p className="text-sm font-semibold text-gray-400 tracking-widest">
                    {member.role}
                  </p>
                </div>

                {/* Bottom decorative wave */}
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-500 via-fuchsia-500 to-pink-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500"></div>
              </div>

              {/* Floating particles on hover */}
              {activeCard === member.id && (
                <>
                  <div className="absolute -top-4 -left-4 w-3 h-3 bg-purple-400 rounded-full animate-float"></div>
                  <div className="absolute -top-6 right-1/4 w-2 h-2 bg-fuchsia-400 rounded-full animate-float" style={{ animationDelay: '0.3s' }}></div>
                  <div className="absolute -bottom-4 -right-4 w-3 h-3 bg-pink-400 rounded-full animate-float" style={{ animationDelay: '0.6s' }}></div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px) scale(1);
            opacity: 1;
          }
          50% {
            transform: translateY(-20px) scale(1.2);
            opacity: 0.6;
          }
        }

        .animate-fadeInDown {
          animation: fadeInDown 1s ease-out;
        }

        .animate-fadeInUp {
          animation: fadeInUp 1s ease-out;
          animation-fill-mode: both;
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
}